import { Text } from "@wojo/ui";
import React from "react";
import { VerifyEmailForm } from "../forms/VerifyEmailForm";
import { Title } from "../title";

export const VerifyEmailWishlistView: React.FC = () => {
    return (
        <>
            <Title>Before you can add to your wishlist…</Title>
            <Text style={{ marginBottom: "var(--g-spacing-md)" }}>
                Log in or register with your email address.
            </Text>
            <VerifyEmailForm />
        </>
    );
};
